import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AsyncThunk } from '@reduxjs/toolkit';

import type { Task } from '../../types';
import type { ReduxStore } from '../store';

import { triggerRebuild } from './api';
import * as GlobalLicenseCorrectionStore from './slice';

/** Kicks off a rebuild of the current revision */

export const rebuildRevision: AsyncThunk<Task, void, { state: ReduxStore; }> = createAsyncThunk<Task>(
  'globalLicenseCorrections/rebuildRevision',
  async (_args, { getState }) => {
    const projectValue = GlobalLicenseCorrectionStore.selectors.projectSelector(getState() as ReduxStore);
    if (projectValue.isLoading || !projectValue.value?.locator) {
      throw new Error('Cannot rebuild while loading.');
    }

    return triggerRebuild(projectValue.value.locator);
  },
);
